import { SERVICES } from "@/data/site";
import { Brush, Home, ChefHat, Hammer, Building2, Construction, TreePine, Palette } from "lucide-react";

const ICONS = [Brush, Home, ChefHat, Hammer, Building2, Construction, TreePine, Palette];
const GRADIENTS = [
  "from-amber-400 to-yellow-400",
  "from-blue-500 to-teal-500",
  "from-orange-500 to-rose-500",
  "from-emerald-500 to-cyan-500",
  "from-yellow-400 to-pink-500",
  "from-amber-500 to-orange-500",
  "from-teal-500 to-emerald-500",
  "from-violet-500 to-amber-400",
];

export function ServicesGrid({ title = "Artisan capabilities", subtitle = "Comprehensive finishing services for architectural integrity and lasting value." }: { title?: string; subtitle?: string }) {
  return (
    <section className="py-16 sm:py-28 lg:py-36 bg-[#030303] relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 relative">
        <div className="mb-10 sm:mb-16 max-w-2xl">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 text-[10px] sm:text-[11px] font-medium tracking-widest uppercase text-amber-200 mb-4 sm:mb-5">
            Capabilities
          </div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-6xl text-white mb-3 sm:mb-4 leading-tight">{title}</h2>
          <p className="text-zinc-400 text-base sm:text-lg max-w-[52ch] text-pretty">{subtitle}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div key={s.title} className="group relative p-5 sm:p-7 rounded-3xl bg-white/[0.03] border border-white/10 backdrop-blur-sm hover:border-amber-400/40 hover:bg-white/[0.05] transition-all duration-700">
                <div className={`h-11 w-11 rounded-xl bg-gradient-to-tr ${GRADIENTS[i % GRADIENTS.length]} mb-4 sm:mb-5 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-500`}>
                  <Icon className="size-5 text-white" />
                </div>
                <h3 className="font-serif text-lg sm:text-xl text-white mb-2">{s.title}</h3>
                <p className="text-sm text-zinc-500 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
